<template>
    <div class="multi-level-choices">
        <div class="combobox-containers">
            <div class="combobox-container" v-for="(item,index) in levels" :key="index">
                <div class="label">{{ level_names[index] }}</div>
                <combo-box :options="getOptionsInLevel(index)"
                           ref="comboboxes"
                           @valueChanged="onComboboxValueChanged"
                           :initial-value="getValueInLevel(index)"
                ></combo-box>
            </div>
        </div>
    </div>
</template>

<script>
import InputControlBase from "@/InputControls/InputControlBase";
import ComboBox from "@/InputControls/ComboBox";

export default {
    name: "MultiLevelChoices",
    components: {ComboBox},
    mixins: [InputControlBase],
    props: {
        all_option_values: Array,
        level_names: Array,
    },
    methods: {
        onComboboxValueChanged() {
            if (this.ignoreInnerValueChanges) {
                return
            }
            const {comboboxes} = this.$refs;
            let newValue = [];
            let allNull = true;
            comboboxes.forEach(b => {
                let v = b.getValue();
                newValue.push(v);
                if (v !== null) {
                    allNull = false;
                }
            })
            if (allNull) {
                newValue = null;
            }
            if (this.value !== newValue) {
                this.value = newValue;
            }
        },
        setInputValue(value) {
            if (this.value === value) {
                return
            }
            this.value = value;
            if (!value) {
                value = [...Array(this.levels)].map(() => null);
            }

            this.ignoreInnerValueChanges = true;
            const {comboboxes} = this.$refs;
            this.$nextTick(() => {
                comboboxes.forEach((b, i) => {
                    b.setInputValue(value[i]);
                });
                this.$nextTick(() => {
                    this.ignoreInnerValueChanges = false;
                })
            })
        },
        focus() {
        },
        getOptionsInLevel(level) {
            const {value, all_option_values, levels} = this;
            let options = [{value: null, label: ''}];
            let valuesOfLevels;
            if (value) {
                valuesOfLevels = value;
            } else {
                valuesOfLevels = [];
                for (let i = 0; i < levels; i++) {
                    valuesOfLevels.push(null);
                }
            }
            if (level === 0) {
                return options.concat(all_option_values.map(v => ({
                    label: v.option_label,
                    value: v.option_value,
                    children: v.children,
                })))
            }
            let valueInPrevLevel = valuesOfLevels[level - 1];
            if (valueInPrevLevel) {
                const optionsInPrevLevel = this.getOptionsInLevel(level - 1);
                for (let i = 0; i < optionsInPrevLevel.length; i++) {
                    if (optionsInPrevLevel[i].value === valueInPrevLevel && optionsInPrevLevel[i].children) {
                        return options.concat(optionsInPrevLevel[i].children.map(v => ({
                            label: v.option_label,
                            value: v.option_value,
                            children: v.children,
                        })))
                    }
                }
            }
            return options;
        },
        getValueInLevel(level) {
            if (this.value) {
                return this.value[level];
            }
            return null;
        }
    },
    created() {
        this.value = this.value || null;
    },
    mounted() {
    },
    data() {
        return {
            ignoreInnerValueChanges: false,
        }
    },
    computed: {
        levels() {
            let levels = 1;
            const {all_option_values} = this;
            let temp = all_option_values[0];
            while (temp.children) {
                levels++;
                temp = temp.children[0];
            }
            return levels;
        },
    }
}
</script>

<style scoped lang="scss">
@import "input-controls";

.combobox-containers {
    display: flex;

    .combobox-container {
        align-items: center;
        flex: 1 1 0;

        &:not(:last-child) {
            margin-right: 0.75rem;
        }

        .label {
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: 600;
            color: #777777;
            font-size: 0.95em;
            margin-left: 0.25rem;
            margin-bottom: 4px;
            padding-top: 2px;
        }
    }
}
</style>
